import React, { useCallback, useRef, useState } from "react";
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Icon, } from "@chakra-ui/react";
import { MotionConfig } from "framer-motion";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "./button";
export function ConfirmationDialog({ isOpen, isConfirmButtonDisabled = false, title, children, confirmButtonText, variant, onClose, onCancel, onConfirm, }) {
    const cancelButton = useRef(null);
    const canceled = useCallback(() => {
        if (typeof onCancel === "function") {
            onCancel();
        }
        onClose();
    }, [onCancel, onClose]);
    const [isConfirming, setIsConfirming] = useState(false);
    const confirmed = useCallback(async () => {
        const promise = onConfirm();
        if (promise instanceof Promise) {
            try {
                setIsConfirming(true);
                await promise;
            }
            finally {
                setIsConfirming(false);
            }
        }
        onClose();
    }, [onConfirm, onClose]);
    return (React.createElement(MotionConfig, { transition: { duration: 5 } },
        React.createElement(AlertDialog, { isOpen: isOpen, leastDestructiveRef: cancelButton, onClose: onClose },
            React.createElement(AlertDialogOverlay, null,
                React.createElement(AlertDialogContent, { w: "sm", motionProps: {
                        initial: {
                            scale: 0.9,
                            opacity: 0,
                        },
                        variants: {
                            enter: {
                                scale: 1,
                                opacity: 1,
                                transition: {
                                    type: "spring",
                                    damping: 30,
                                    stiffness: 1600,
                                },
                            },
                            exit: {
                                scale: 0.9,
                                opacity: 0,
                                transition: {
                                    type: "spring",
                                    duration: 0.15,
                                },
                            },
                        },
                    } },
                    React.createElement(Box, { mx: "auto", width: 12, height: 12, borderRadius: "full", bg: variant === "danger" ? "red.200" : "yellow.200", display: "flex", alignItems: "center", justifyContent: "center" },
                        React.createElement(Icon, { as: ExclamationTriangleIcon, boxSize: 6, color: variant === "danger" ? "red.600" : "yellow.600" })),
                    React.createElement(AlertDialogHeader, { mt: 4, textAlign: "center" }, title),
                    React.createElement(AlertDialogBody, { textAlign: "center" }, children),
                    React.createElement(AlertDialogFooter, null,
                        React.createElement(Button, { ref: cancelButton, isJustified: true, isDisabled: isConfirming, onClick: canceled }, "Cancel"),
                        React.createElement(Button, { isJustified: true, isLoading: isConfirming, isDisabled: isConfirmButtonDisabled, variant: variant === "danger" ? "danger" : "primary", onClick: confirmed }, confirmButtonText)))))));
}
